import React from "react";
import { IAppointment } from "types/IAppointment";
import { format } from "date-fns";
import { getStrictFormattedAddress } from "utils/getStrictFormattedAddress";
import { AppointmentSlot, IRebookInfo } from "../../../../../../components/AppointmentSlot/AppointmentSlot";
import { getIconForLocationType } from "../../../../../../components/LocationTypeImageIcon/getIconForLocationType";
import { AppointmentStatusCodes } from "app/consts/AppointmentStatusCodes";

interface PastAppointmentSlotProps {
   appointment: IAppointment;
}

const PastAppointmentDesktopSlot: React.FC<PastAppointmentSlotProps> = ({
   appointment,
}) => {
   const Month: string = format(
      new Date(appointment.appointmentDateTime),
      "MMM",
   );
   const Day: string = format(new Date(appointment.appointmentDateTime), "dd");

   // SCREDP-42: display rebook button only for appointments that are not future, not rebook pending and impacted appointments
   const displayRebookButton = (): IRebookInfo | null => {
      const rebookInfo = {accountName: appointment?.drive?.account?.accountName, locationCode: appointment?.drive?.location?.locationCode};

      if (appointment.appointmentStatusCode === AppointmentStatusCodes.REBOOK_PENDING ||
          appointment.appointmentStatusCode === AppointmentStatusCodes.IMPACTED_APPOINTMENT || 
            (appointment.outcome !== 'Canceled' && new Date(appointment.appointmentDateTime) > new Date())) {
         return null;
      }

      return rebookInfo;
   };

   return (
      <AppointmentSlot
         month={Month}
         day={Day}
         iconSrc={getIconForLocationType(
            appointment?.drive?.location?.locationType,
         )}
         name={appointment?.drive?.account?.accountName}
         // include account name (SCREDP-53)
         accountName={appointment?.drive?.account?.accountName}
         // include location name (SCRDEP-63)
         locationName={appointment?.drive?.location?.name}
         subTitle={getStrictFormattedAddress(appointment?.drive?.location)}
         rightTopLabel={"Appt Type"}
         rightTopValue={appointment?.appointmentTypeDescription}
         rightBottomLabel={"Status"}
         rightBottomValue={appointment.outcome}
         rebookInfo={displayRebookButton()}
      />
   );
};

export default PastAppointmentDesktopSlot;
